/**
 * The top level views on the supplier risk management page. The risks view is keyed on the driver
 * schedule, so work with no schedule set can only be seen in the unscheduled tasks view.
 */
export enum RiskManagementView {
  Risks = 0,
  UnscheduledTasks = 1,
  /** Audit trail of supplier assignments. Only available to risk management admins. */
  AssignmentHistory = 2,
}
